const electricity_contract = `Hei, Haluan tiedustella sähkösopimusta.
Hello, I am looking to inquire about an electricity contract. 

Voisitteko antaa minulle tietoja käytettävissä olevista sopimusvaihtoehdoista,
Could you please provide me with information about the available contract options, 

mukaan lukien hinnat ja ehdot? Lisäksi,
including details on pricing and terms? Additionally, 

Haluaisin tietää menettelyn sopimuksen aloittamiseksi.
I would like to know the procedure for initiating the contract. 

Kiitos avustanne
Thank you for your assistance`;

export default electricity_contract;